/***
 *
 *   LOGO
 *   Replace the image in /images with your own logo
 *
 **********/

import React, { useContext } from "react";
import { Link, ClassHelper, AuthContext } from "components/lib";
// StackGo is the container brand. IdentityCheck now appears as a
// "Powered by IdentityCheck" mark on the components it powers, not in the shell.
import LogoWhite from "./images/StackGo_Logo_White.png";
import LogoColor from "./images/StackGo_Logo_Colour.png";
import LogoMark from "./images/go-mark.svg";
import Style from "./logo.tailwind.js";

// Collapsed sidebar uses the dedicated StackGo "go" tile; the mark reads on
// both light and dark rails, so the same asset serves colour and white.
const LogoMarkWhite = LogoMark;
const LogoMarkColor = LogoMark;

export function Logo(props) {
  const Logo = {
    color: {
      logo: LogoColor,
      mark: LogoMarkColor,
    },
    white: {
      logo: LogoWhite,
      mark: LogoMarkWhite,
    },
  };

  const logoStyle = ClassHelper(Style, props);
  const context = useContext(AuthContext);
  const isUser = context.user?.token;
  const link = isUser ? "/dashboard" : "https://www.stackgo.io";

  return (
    <Link url={link} className={logoStyle}>
      <img
        src={
          Logo[props.color ? "color" : "white"][props.mark ? "mark" : "logo"]
        }
        alt="Logo"
      />
    </Link>
  );
}
